import { theme } from "../../theme";

const arrowColor = (disabled) => {
  return disabled ? theme.color.waterloo : theme.color.scienceblue;
};

export const BackArrow = ({ disabled }) => (
  <svg
    width="5"
    height="8"
    viewBox="0 0 5 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.222864 3.49346C0.080164 3.62781 0 3.81002 0 4C0 4.18998 0.080164 4.37219 0.222864 4.50654L3.71898 7.79729C3.86078 7.92809 4.0517 8.00093 4.25023 7.99999C4.44877 7.99905 4.63889 7.92439 4.77928 7.79225C4.91967 7.66011 4.99899 7.48115 4.99999 7.29428C5.00099 7.1074 4.9236 6.9277 4.78464 6.79423L1.81602 4L4.78464 1.20577C4.9236 1.0723 5.00099 0.892599 4.99999 0.705723C4.99899 0.518847 4.91967 0.339893 4.77928 0.20775C4.63889 0.0756075 4.44877 0.000952901 4.25023 9.05896e-06C4.0517 -0.000934783 3.86078 0.0719085 3.71898 0.20271L0.222864 3.49346Z"
      fill={arrowColor(disabled)}
    />
  </svg>
);

export const ForArrow = ({ disabled }) => (
  <svg
    width="5"
    height="8"
    viewBox="0 0 5 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.77714 3.49346C4.91984 3.62781 5 3.81002 5 4C5 4.18998 4.91984 4.37219 4.77714 4.50654L1.28102 7.79729C1.13922 7.92809 0.948305 8.00093 0.749766 7.99999C0.551227 7.99905 0.361106 7.92439 0.220716 7.79225C0.0803261 7.66011 0.00101237 7.48115 9.62432e-06 7.29428C-0.000993122 7.1074 0.0763962 6.9277 0.215361 6.79423L3.18398 4L0.215361 1.20577C0.0763962 1.0723 -0.000993122 0.892599 9.62432e-06 0.705723C0.00101237 0.518847 0.0803261 0.339893 0.220716 0.20775C0.361106 0.0756075 0.551227 0.000952901 0.749766 9.05896e-06C0.948305 -0.000934783 1.13922 0.0719085 1.28102 0.20271L4.77714 3.49346Z"
      fill={arrowColor(disabled)}
    />
  </svg>
);
